import React from "react";
import { useSelector } from "react-redux";
import EmptyData from "../../StyledComponents/EmptyData";
import { TableRow, TableBody } from "../../StyledComponents";
import {
  Container,
  Title,
  StatusBadge,
  TableWrapper,
  StyledTable,
  StickyHeader,
  HeaderCell,
  BodyCell,
  CellText,
} from "./styles";

const HealthScreening = () => {
  const screeningData = useSelector(
    (state) => state.HealthProfile.HealthScreeningList,
  );

  const headers = [
    "Provider Name",
    "Test Name",
    "Done Date",
    "Due Date",
    "Status",
    "Type",
  ];

  const getStatusClassName = (status) => {
    const currentStatus = (status || "").toLowerCase();

    if (currentStatus === "overdue") return "status-overdue";
    if (currentStatus === "due") return "status-due";
    if (currentStatus === "due soon") return "status-due-soon";
    if (currentStatus === "completed") return "status-completed";
    if (currentStatus === "upcoming") return "status-upcoming";

    return "status-default";
  };

  return (
    <Container>
      <Title>Health Screening List</Title>
      <TableWrapper>
        <StyledTable>
          <StickyHeader>
            <TableRow>
              {headers.map((header) => (
                <HeaderCell key={header}>{header}</HeaderCell>
              ))}
            </TableRow>
          </StickyHeader>
          <TableBody>
            {screeningData && screeningData.length > 0 ? (
              screeningData.map((row, ind) => (
                <TableRow
                  background="#FFFFFF"
                  key={row.id || row.guideline_id || ind}
                >
                  <BodyCell>
                    <CellText>{row.providerName || "-"}</CellText>
                  </BodyCell>

                  <BodyCell>
                    <CellText>{row.testName || "-"}</CellText>
                  </BodyCell>

                  <BodyCell>
                    <CellText>{row.doneDate || "-"}</CellText>
                  </BodyCell>

                  <BodyCell>
                    <CellText>{row.dueDate || "-"}</CellText>
                  </BodyCell>

                  <BodyCell>
                    {row.status ? (
                      <StatusBadge className={getStatusClassName(row.status)}>
                        {row.status}
                      </StatusBadge>
                    ) : (
                      <CellText>-</CellText>
                    )}
                  </BodyCell>

                  <BodyCell>
                    <CellText>{row.type || "-"}</CellText>
                  </BodyCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <BodyCell colSpan={6} textAlign="center">
                  <EmptyData />
                </BodyCell>
              </TableRow>
            )}
          </TableBody>
        </StyledTable>
      </TableWrapper>
    </Container>
  );
};

export default HealthScreening;
